import React, { useState, useEffect } from "react";
import logo from "../../images/logo.png";
import miniLogo from "../../images/miniLogo.png";
import { format } from "date-fns";

import group from "../../images/group.jpg";
import {
	StackedCarousel,
	ResponsiveContainer,
} from "react-stacked-center-carousel";
//   import {Fab} from "@material-ui/core";
// import testlefticon from "../assets/pictures/testlefticon.svg"
// import testrightiicon from "../assets/pictures/testrightiicon.svg"
//   import ArrowBackIcon from '@mui/icons-material/ArrowBack';
//   import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Slide } from "./testimonial.jsx";
import shape8 from "../../images/shape-8.png";
import shape5 from "../../images/shape-5.png";
import shape6 from "../../images/shape-6.png";
import shape7 from "../../images/shape-7.png";
import shape9 from "../../images/shape-9.png";
import shape10 from "../../images/shape-10.png";
import shape12 from "../../images/shape-12.png";
import shape13 from "../../images/shape-13.png";
import shape15 from "../../images/shape-15.png";
import shape16 from "../../images/shape-16.png";
import shape17 from "../../images/shape-17.png";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
// import books from '../../images/books.jpg';
import collage from "../../images/collage.jpg";
import googlePlay from "../../images/googlePlay.png";
import apple from "../../images/apple.png";

import call from "../../images/call.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ScrollTrigger from "react-scroll-trigger";
// import "~slick-carousel/slick/slick.css";
// import "~slick-carousel/slick/slick-theme.css";
import slider1 from "../../images/slider-1.png";
import { useTimer } from "react-timer-hook";
import dr2 from "../../images/drAyman.jpg";
import dr1 from "../../images/drSherin.PNG";
import mostafa from "../../images/mostafa.jpg";
import abdelrahman from "../../images/abdelrahman.jpg";
import mahmoud from "../../images/mahmoud.jpg";
import youssef from "../../images/youssef.jpg";
import blog1 from "../../images/blog1.jpg";
import blog2 from "../../images/blog2.png";
import blog3 from "../../images/blog3.jpg";
import shape21 from "../../images/shape-21.png";
import shape22 from "../../images/shape-22.png";
import Accordion from "react-bootstrap/Accordion";
import author from "../../images/author-03.jpg";
import mobile1 from "../../images/BG mobile.png";
import mobile2 from "../../images/mobiless.png";
import lap2 from "../../images/laptop.png";
import books from "../../images/bookss.jpg";
import magnet from "../../images/call.jpg";

import { Swiper, SwiperSlide } from "swiper/react";
import {
	Navigation,
	Pagination,
	Scrollbar,
	A11y,
	EffectFade,
	EffectCube,
	EffectFlip,
	Autoplay,
	EffectCoverflow,
} from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import "swiper/css/effect-cube";

import { useRef } from "react";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import ReactCountdownClock from "react-countdown-clock";
import myCallback from "react-countdown-clock";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import Slider from "react-slick";
import axios from "axios";
const Home = () => {
	// var Slider = require('react-slick');

	//     let days =document.getElementById('days');
	//     let minutes =document.getElementById('minutes');
	//     let hours =document.getElementById('hours');
	//     let seconds =document.getElementById('seconds');
	//     let dd =document.getElementById('dd');
	//     let mm =document.getElementById('mm');
	//     let ss =document.getElementById('ss');
	//     let hh =document.getElementById('hh');
	// let dayDot=document.querySelector('.dayDot');
	// let minDot=document.querySelector('.minDot');
	// let secDot=document.querySelector('.secDot');
	// let hrDot=document.querySelector('.hrDot');
	// let endDate= '3/15/2023 00:00:00';
	// let x = setInterval(function(){
	//     let now = new Date(endDate).getTime();
	//     let countDown= new Date().getTime();
	//     let distance = now - countDown;
	//     let d = Math.floor(distance / (1000 * 60 * 60 * 24));
	//     let h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) ;
	//     let m = Math.floor((distance % (1000 * 60 * 60 )) / (1000 * 60 )) ;
	//     let s = Math.floor((distance % (1000 * 60 )) / (1000 )) ;

	//     days.innerHTML = d + "</br> <span>Days</span>";
	//     hours.innerHTML = h + "</br> <span>hours</span>";
	//     minutes.innerHTML = m + "</br> <span>minutes</span>";
	//     seconds.innerHTML = s + "</br> <span>seconds</span>";

	//     dd.style.strokeDashoffset= 440 - (440 * d) / 365;
	//     hh.style.strokeDashoffset= 440 - (440 * h) / 24;
	//     mm.style.strokeDashoffset= 440 - (440 * m) / 60;
	//     ss.style.strokeDashoffset= 440 - (440 * s) / 60;

	//     dayDot.style.transform= `rotateZ(${d * 0.986}deg)`;
	//     hrDot.style.transform= `rotateZ(${h * 15}deg)`;
	//     minDot.style.transform= `rotateZ(${m * 6}deg)`;
	//     secDot.style.transform= `rotateZ(${s * 6}deg)`;

	//     if(distance < 0){
	//         clearInterval(x);
	//         document.getElementById('time').style.display='none'
	//         document.querySelector('.newCourse').style.display='block'

	//     }
	// })
	// const [blogs, setBlogs] = useState([]);

	// async function getBlogs() {
	//     let { data } = await axios.post(
	//       `https://maps-medics-be.onrender.com/show_blogs` ,
	//     );
	//     setBlogs(data.result);

	//     console.log(data.result);
	//   }
	//   useEffect(() => {

	//     getBlogs();
	//   }, []);
	const [data, setData] = useState([
		{
			image: ` ${blog1}`,
			text: (
				<Link to="/blog1" style={{ textDecoration: "none", color: "#fff" }}>
					{" "}
					<p>
						{" "}
						With Numbers: What is the average salary and lifestyle of a
						physician in the USA?
						<br /> <span> Maps Team | January 27, 2023</span>
					</p>{" "}
					,
				</Link>
			),
		},
		{
			image: `${magnet}`,
			text: (
				<Link to="/blog3" style={{ textDecoration: "none", color: "#fff" }}>
					<p>
						How to Apply for an ECFMG Certification? <br />
						<br /> <span> Maps Team | January 27, 2023</span>
					</p>{" "}
				</Link>
			),
		},
		{
			image: `${books}`,
			text: (
				<Link to="/blog2" style={{ textDecoration: "none", color: "#fff" }}>
					{" "}
					<p>
						What is the USMLE?
						<br /> <span> Maps Team | January 27, 2023</span>
					</p>{" "}
				</Link>
			),
		},
	]);
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const ref = React.useRef(StackedCarousel);
	useEffect(() => {
		setInterval(1000);
		console.log("i fire once");
	}, []);

	useEffect(() => {
		axios
			.post(`https://maps-medics-be.onrender.com/show_blogs`)
			.then((res) => {
				if (res.data.result) {
					let arr = res.data.result.map((one) => {
						return {
							image: ` ${one.image}`,
							text: (
								<Link
									to={`/blog4/${one.id}`}
									style={{ textDecoration: "none", color: "#fff" }}
								>
									{" "}
									<p>
										{" "}
										{one.smail_text}
										<br />{" "}
										<span>
											{" "}
											Maps Team | {format(new Date(one.date), "MMM dd, yyyy")}
										</span>
									</p>{" "}
									
								</Link>
							),
						};
					});
					setData(data.concat(arr));
				}
			})
			.catch((e) => {
				console.log(e);
			});
	}, []);

	function stuff() {
		ref.current?.goNext();
	}
	const [counterOn, setCounterOn] = useState(false);
	const time = new Date();

	// const settings = {
	//     dots: true,
	//     // className: "center",
	//     // centerMode: true,
	//     infinite: true,
	//     // centerPadding: "60px",
	//     slidesToShow: 3,
	//     speed: 500
	//   };

	// time.setSeconds(time.getSeconds() + 208800);
	// const {
	//     seconds,
	//     minutes,
	//     hours,
	//     days,
	//     isRunning,
	//     start,
	//     pause,
	//     resume,
	//     restart,
	//   } = useTimer({ time, onExpire: () => console.warn('onExpire called') });

	return (
		<>
			{/* <Navbar/> */}
			<div class="section slider-section">
				<div
					class="container-fluid"
					style={{ position: "relative", padding: "0" }}
				>
					<div class="slider-content" style={{ paddingLeft: "10%" }}>
						<h4
							class="sub-title"
							style={{
								fontFamily: "Poppins",
								fontSize: "20px",
								fontWeight: "500",
								lineHeight: "1.2em",
							}}
						>
							Map Your Way To Success
						</h4>
						<h1
							class="main-title"
							style={{
								color: "#fff",
								fontWeight: "900",
								lineHeight: "1.2em",
								fontSize: "50px",
								marginBottom: ".5rem",
								fontFamily: "Playfair Display",
								textShadow: "0px 0px 2px #ffc600",
							}}
						>
							Empowering Medical Students To Ace The USMLE, One Case At A Time.
						</h1>
						<p
							style={{
								color: "#fff",
								fontFamily: "Poppins",
								fontSize: "20px",
								fontWeight: "500",
								lineHeight: "1.2em",
							}}
						>
							Experience the Power of Case-Based Learning
						</p>
						<Link class="btn  startLearning" to="/courses">
							START LEARNING NOW <i class="fa-solid fa-book-open"></i>
						</Link>
					</div>
					<div className="stickyBanner">
						<div
							className="pl2"
							style={{
								borderLeft: "#ffc600 2px solid",
								color: "rgba(74,74,74,.65)",
							}}
						>
							<p
								style={{ color: "#fff", fontWeight: "300", paddingLeft: "5px" }}
							>
								Maps Medics
							</p>
							<div
								style={{ color: "#fff", fontWeight: "300", paddingLeft: "5px" }}
							>
								Announcing the launch of our USMLE®️ Step 1 Preparatory Course.
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="container p-3">
				<div
					className="row p-5"
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						textAlign: "center",
					}}
				>
					{/* <p style={{fontSize:'16px', fontWeight:'600' , textTransform:'uppercase', textShadow:'0px 0px 10px rgb(0 0 0 / 30%)', textAlign:'center', color:'#fec329', margin:'0px 0px 15px 0px'}}>TIMECOUNTING</p> */}
					{/* 
<h1 >Starting Soon, Wait this blooming
 </h1> */}
					<h6
						style={{
							fontSize: "16px",
							fontWeight: "600",
							textTransform: "uppercase",
							textShadow: "0px 0px 10px rgb(0 0 0 / 30%)",
							color: "#fec329",
							margin: "0px 0px 15px 0px",
							textAlign: "center",
							fontFamily: "Poppins",
						}}
					>
						UNLOCK YOUR POTENTIAL
					</h6>
					<h1 style={{ textAlign: "center", fontWeight: "bold" }}>
						Take Control of Your Medical Education
					</h1>
					{/* <div class="typewriter">
  <h1>The cat and the hat.</h1>
</div> */}

					<h1
						style={{
							paddingTop: "4%",
							fontStyle: "italic",
							fontWeight: "600",
							fontSize: "30px",
							display: "flex",
							justifyContent: "center",
						}}
					>
						<div id="fragment1">A Warm Welcome Home</div>
					</h1>
					{/* <div style={{display:'flex' , justifyContent:'center'}}> 
 <ReactCountdownClock seconds={43200}
                     color="#ffc600"
                     alpha={0.9}
                     size={300}
                     onComplete={myCallback}
                     
                     /></div> */}
				</div>
			</div>
			{/* <div class=" clock" >
<div style={{backgroundColor:'rgba(0,0,0,0.4)', paddingBottom:'80px', paddingTop:'80px'}}>


<div className="container" style={{paddingBottom:'1%'}}>
    <h1 style={{fontFamily:'Poppins' , color:'#fff' , textAlign:'center'}}>Next Live</h1>
</div>
   <div className="container">
   
        <div className="col-md-12 col-sm-12 col-xs-12">
        <div id='time' style={{justifyContent:'center', flexWrap:'wrap' }}>
<div className='circle' style={{color:'#fff'}}>
<div className="dots dayDot" style={{backgroundColor:'rgba(0, 0, 0, 0.5)'}}></div>
<svg style={{zIndex:111111}}>
<circle cx='70' cy='70' r='70'></circle>

    <circle cx='70' cy='70' r='70' id='dd'></circle>
</svg>
<div id='days' style={{zIndex:111111}}>
00 <br /> <span>Days</span>
</div>
</div>
<div className='circle' style={{color:'#fff'}}>
<div className="dots hrDot" style={{backgroundColor:'rgba(0, 0, 0, 0.5)'}}></div>
<svg style={{zIndex:111111}}>
<circle cx='70' cy='70' r='70'></circle>

    <circle cx='70' cy='70' r='70' id='hh'></circle>
</svg>
<div id='hours' style={{zIndex:111111}}>
00
</div>
</div>
<div className='circle' style={{color:'#fff'}}>
<div className="dots minDot" style={{backgroundColor:'rgba(0, 0, 0, 0.5)'}}></div>
<svg style={{zIndex:111111}} >
<circle cx='70' cy='70' r='70' ></circle>

    <circle cx='70' cy='70' r='70' id='mm' ></circle>
</svg>
<div id='minutes' style={{zIndex:111111}}>
00
</div>
</div>
<div className='circle' style={{color:'#fff'}}>
<div className="dots secDot"  style={{backgroundColor:'rgba(0, 0, 0, 0.5)'}}></div>
<svg style={{zIndex:111111}}>
<circle cx='70' cy='70' r='70'></circle>

    <circle cx='70' cy='70' r='70' id='ss'></circle>
</svg>
<div id='seconds' style={{zIndex:111111}}>
00
</div>
</div>
</div>
        </div>
  
   </div>

  


</div>
</div> */}

			{/* <section style={{minHeight:'55vh' , display:'flex' , justifyContent:'space-around', overflow:'hidden' }}>
   
        <span className='oeBg'></span>
   <div className="oeEmpty" style={{position:'relative', backgroundColor:'rgba(0, 0, 0, 0.5)' , color:'#ffffff'}}>
<section  class="s_countdown pt48 pb48 o_colored_level" data-display="dhms" data-end-action="nothing" data-size="175" data-layout="circle" data-layout-background="inner" data-progress-bar-style="disappear" data-progress-bar-weight="thin" data-text-color="o-color-3" data-layout-background-color="black-50" data-progress-bar-color="o-color-1" data-snippet="s_countdown" data-end-time="1675220247.415198" data-name="Countdown" style={{backgroundImage:'none', paddingBottom:'48px', paddingTop:'48px', position:'relative'}}>
<div className="container">
<div class="s_countdown_canvas_wrapper text-center d-flex justify-content-center">
    <div class="s_countdown_canvas_flex"><canvas class="w-100" width="175" height="175"></canvas></div>
    <div class="s_countdown_canvas_flex"><canvas class="w-100" width="175" height="175"></canvas></div>
    <div class="s_countdown_canvas_flex"><canvas class="w-100" width="175" height="175"></canvas></div>
    <div class="s_countdown_canvas_flex"><canvas class="w-100" width="175" height="175"></canvas></div>
    </div>
</div>
</section>
   </div>
</section> */}
			{/* <div className="section section-padding-02" style={{display:'flex' , justifyContent:'center' , alignItems:'center'}}>
            <div class="container" >
                <div className="row">
                    <h6 style={{fontSize:'16px', fontWeight:'600' , textTransform:'uppercase', textShadow:'0px 0px 10px rgb(0 0 0 / 30%)', color:'#fec329', margin:'0px 0px 15px 0px', textAlign:'center'}}>
                    UNLOCK YOUR POTENTIAL

                    </h6>
                    <h1 style={{textAlign:'center'}}>
                    Take Control of Your Medical Education

                    </h1>
                </div>
                <div className='m-3' style={{display:'flex' , justifyContent:'center' , alignItems:'center'}}>
                <div class=" row" style={{width:'80%' , border:'solid 1px #ffa02630' , borderRadius:'20px',display:'flex' , justifyContent:'center' , alignItems:'center' }}>
<div className="col-md-2 p-2">
<img src={dr1} class="card-img-top" style={{borderRadius:'10px'}} alt="Dr Ayman"/>

</div>
<div className="col-md-10">
<div class="card-body">
    <p class="card-text" style={{fontWeight:'bold'}}>
Introducing Maps Medics, the ultimate resource for medical students at MTI University. Aligned with our vision for success, this comprehensive on-demand platform offers a unique case-based approach, high-yield questions, and expert support. Achieve success on your journey with Maps Medics.</p>
<div className="sectionIneer" style={{ border:'1px solid #ffc600 ', transition:'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s', borderRadius:'20px'}}>
                                          <div className="row p-2">
                                            <div className="col-md-6">
                                            <h5 style={{fontWeight:'bold'}}>Prof. Dr. Ayman Shafei</h5>

                                            </div>
                                            <div className="col-md-6">
                                            <span class="designation" style={{fontSize:'16px', fontWeight:'600' , textTransform:'uppercase', textShadow:'0px 0px 10px rgb(0 0 0 / 30%)', color:'#fec329', margin:'0px 0px 15px 0px'}}>Prof. Dr. Ayman Shafei</span>

                                            </div>
                                            </div> 
                                            

                                           
                                            </div>
  </div>
</div>

</div>
                </div>
       
                <div className='m-3' style={{display:'flex' , justifyContent:'center' , alignItems:'center'}}>
                <div class=" row" style={{width:'80%' , border:'solid 1px #ffa02630' , borderRadius:'20px',display:'flex' , justifyContent:'center' , alignItems:'center' }}>
<div className="col-md-2 p-2">
<img src={dr2} class="card-img-top" style={{borderRadius:'10px'}} alt="Dr Sherin"/>

</div>
<div className="col-md-10">
<div class="card-body">
    <p class="card-text" style={{fontWeight:'bold'}}>Exciting news for MTI medical students! Maps Medics offers a case-based approach, over 3,600 questions, and personalized support for your USMLE success. As Vice-Dean, I strongly recommend joining the Maps Medics community for a reliable shortcut to success.</p>
    <div className="sectionIneer" style={{ border:'1px solid #ffc600 ', transition:'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s', borderRadius:'20px'}}>
                                          <div className="row p-2">
                                            <div className="col-md-6">
                                            <h5 style={{fontWeight:'bold'}}>Prof. Dr. Sherin Wagih</h5>

                                            </div>
                                            <div className="col-md-6">
                                            <span class="designation" style={{fontSize:'16px', fontWeight:'600' , textTransform:'uppercase', textShadow:'0px 0px 10px rgb(0 0 0 / 30%)', color:'#fec329', margin:'0px 0px 15px 0px'}}>Vice Dean, College Of Medicine, MTI university</span>

                                            </div>
                                            </div> 
                                            

                                           
                                            </div>
  </div>
</div>

</div>
                </div>

        </div>
        </div> */}
			<div class="section  mt-n1">
				<div class="container">
					<div class="section-title shape-03 text-center">
						{/* <h5 class="sub-title">Student Testimonial</h5> */}
						{/* <h2 class="main-title">Our <span>Doctors</span></h2> */}
					</div>

					<div
						class="testimonial-wrapper testimonial-active"
						style={{ paddingTop: "0px" }}
					>
						<div class="swiper-container container">
							<div class="swiper-wrapper row " style={{ margin: "0" }}>
								<div
									className="col-md-6 p-2"
									style={{ minHeight: "1px", display: "flex" }}
								>
									<div class="single-testimonial swiper-slide">
										<div class="testimonial-content">
											<div
												style={{
													fontSize: "18px",
													fontWeight: "400",
													fontFamily: "Sans-serif",
												}}
											>
												Introducing Maps Medics, the ultimate resource for
												medical students. Aligned with our vision for success,
												this comprehensive on-demand platform offers a unique
												case-based approach, high-yield questions, and expert
												support. Achieve success on your journey.
											</div>
											<div className="section ">
												<div
													className="sectionIneer"
													style={{
														transition:
															"background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s",
														borderRadius: "20px",
													}}
												>
													<div
														className="row p-3"
														style={{
															display: "flex",
															justifyContent: "center",
															alignItems: "center",
														}}
													>
														<div
															className="col-md-3 col-sm-3"
															style={{ padding: "0" }}
														>
															<div class="testimonial-author">
																<div class="author-thumb">
																	<img src={dr1} alt="Author" />

																	{/* <i class="icofont-quote-left"></i> */}
																</div>
															</div>
														</div>
														<div
															className="col-md-9 col-sm-9"
															style={{ padding: "0" }}
														>
															<h6
																style={{
																	fontSize: "20px",
																	fontWeight: "900",
																	fontFamily: "Playfair Display",
																	lineHeight: "1.5em",
																	textTransform: "uppercase",
																	color: "#fec329",
																	margin: "0px 0px 5px 0px",
																	display: "flex",
																}}
															>
																Prof. Dr. Ayman Shafei
															</h6>
															<div
																className="container"
																style={{ display: "flex", padding: "0" }}
															>
																<div className="row">
																	<span
																		style={{
																			fontSize: "0.85em",
																			fontFamily: "Poppins",
																		}}
																	>
																		Dean, College Of Medicine, MTI university
																	</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									className="col-md-6 p-2"
									style={{ minHeight: "1px", display: "flex" }}
								>
									<div class="single-testimonial swiper-slide">
										<div class="testimonial-content">
											<div
												style={{
													fontSize: "18px",
													fontWeight: "400",
													fontFamily: "Sans-serif",
												}}
											>
												Exciting news for MTI medical students! Maps Medics
												offers a case-based approach, over 3,600 questions, and
												personalized support for your USMLE success. As
												Vice-Dean, I strongly recommend joining the Maps Medics
												community for a reliable shortcut to success.
											</div>
											<div className="section ">
												<div
													className="sectionIneer"
													style={{
														transition:
															"background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s",
														borderRadius: "20px",
													}}
												>
													<div
														className="row p-3"
														style={{
															display: "flex",
															justifyContent: "center",
															alignItems: "center",
														}}
													>
														<div className="col-md-3" style={{ padding: "0" }}>
															{" "}
															<div class="testimonial-author">
																<div class="author-thumb">
																	<img src={dr2} alt="Author" />

																	{/* <i class="icofont-quote-left"></i> */}
																</div>
															</div>
														</div>
														<div className="col-md-9" style={{ padding: "0" }}>
															<h6
																style={{
																	fontSize: "20px",
																	fontWeight: "900",
																	fontFamily: "Playfair Display",
																	lineHeight: "1.5em",
																	textTransform: "uppercase",
																	color: "#fec329",
																	margin: "0px 0px 5px 0px",
																	display: "flex",
																}}
															>
																Prof. Dr. Sherin Wagih
															</h6>
															<div
																className="container"
																style={{ display: "flex", padding: "0" }}
															>
																<div className="row">
																	<span
																		style={{
																			fontSize: "0.85em",
																			fontFamily: "Poppins",
																		}}
																	>
																		Vice Dean, College Of Medicine, MTI
																		university
																	</span>
																</div>{" "}
															</div>{" "}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="section section-padding-02">
				<div class="container">
					<div class="call-to-action-wrapper">
						{/* <img class="cat-shape-01 animation-round" src={shape12} alt="Shape"/> */}
						{/* <img class="cat-shape-02" src={shape13} alt="Shape"/> */}
						{/* <img class="cat-shape-03 animation-round" src={shape12} alt="Shape"/> */}

						<div class="row align-items-center">
							<div class="col-md-6">
								<div class="section-title shape-02">
									<img
										src={group}
										alt="group"
										style={{ position: "relative", borderRadius: "20px" }}
									/>
									<div className="row">
										<ScrollTrigger
											onEnter={() => setCounterOn(true)}
											onExit={() => setCounterOn(false)}
										>
											<div
												className="container"
												style={{
													backgroundColor: "#ffc600",
													width: "95%",
													top: "-10%",
													borderRadius: "20px",
													position: "relative",
													transition:
														"background 0.3s, border 0.3s, borderRadius 0.3s, boxShadow 0.3s",
												}}
											>
												<div
													className="row"
													style={{
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
													}}
												>
													<div
														className="col-md-4 col-sm-4 text-center  hamada"
														style={{
															color: "#ffffff",
															fontFamily: "Playfair Display",
															fontSize: "42px",
															fontWeight: "600",
															lineHeight: "0.7em",
															borderRight: "1px solid #FFFFFF",
															padding: "3%",
														}}
													>
														{counterOn && (
															<CountUp
																start={0}
																end={180}
																duration={2}
																delay={0}
																prefix=""
																suffix="+"
															/>
														)}{" "}
														<div
															style={{
																borderRight: "1px solid #FFFFFF",
																fontFamily: "Poppins",
																fontSize: "14px",
																fontWeight: "600",
															}}
														></div>
														<label
															style={{
																color: "#fff",
																fontSize: "14px",
																fontWeight: "600",
																fontFamily: "Poppins",
															}}
															htmlFor=""
														>
															LECTURES
														</label>{" "}
													</div>
													<div
														className="col-md-4 col-sm-4 text-center  second"
														style={{
															color: "#ffffff",
															fontFamily: "Playfair Display",
															fontSize: "42px",
															fontWeight: "600",
															lineHeight: "0.7em",
															borderRight: "1px solid #FFFFFF",
															padding: "3%",
														}}
													>
														{counterOn && (
															<CountUp
																start={0}
																end={1400}
																duration={2}
																delay={0}
																prefix=""
																suffix="+"
															/>
														)}{" "}
														<div
															style={{ borderRight: "1px solid #FFFFFF50" }}
														></div>{" "}
														<label
															style={{
																color: "#fff",
																fontSize: "14px",
																fontWeight: "600",
																fontFamily: "Poppins",
															}}
															htmlFor=""
														>
															VITAL CONCEPTS
														</label>
													</div>
													<div
														className="col-md-4 col-sm-4 text-center third"
														style={{
															color: "#ffffff",
															fontFamily: "Playfair Display",
															fontSize: "42px",
															fontWeight: "600",
															lineHeight: "0.9em",
														}}
													>
														{counterOn && (
															<CountUp
																start={0}
																end={3600}
																duration={2}
																delay={0}
																prefix=""
																suffix="+ "
															/>
														)}
														<div className="row">
															<label
																style={{
																	color: "#fff",
																	fontSize: "14px",
																	fontWeight: "600",
																	fontFamily: "Poppins",
																}}
																htmlFor=""
															>
																{" "}
																HIGH YIELD CASES
															</label>
														</div>
													</div>
												</div>
											</div>
										</ScrollTrigger>
									</div>
								</div>
							</div>
							<div class="col-md-6">
								<h5
									class="sub-title"
									style={{
										fontSize: "16px",
										fontWeight: "600",
										textTransform: "uppercase",
										textShadow: "0px 0px 10px rgb(0 0 0 / 30%)",
										color: "#fec329",
										margin: "0px 0px 15px 0px",
										fontFamily: "Poppins",
									}}
								>
									ABOUT US
								</h5>

								<h2
									class="main-title"
									style={{
										fontWeight: "900",
										fontSize: "46px",
										fontFamily: "Playfair Display",
										lineHeight: "1.2em",
										color: "#222",
									}}
								>
									Revolutionizing Medical Education:
									<span
										style={{
											fontWeight: "900",
											fontSize: "46px",
											fontFamily: "Playfair Display",
											lineHeight: "1.2em",
											color: "#222",
										}}
									>
										The Mission of Maps Medics
									</span>
								</h2>

								<p
									style={{
										fontWeight: "300",
										fontSize: "15px",
										fontFamily: "Poppins",
										lineHeight: "20px",
										color: "#222",
									}}
								>
									At Maps Medics, our e-learning platform helps medical students
									succeed with live lectures and an on-demand video library
									covering over 3,600 board-style questions aligned with the
									USMLE Step 1 curriculum through a case-based approach. Our
									comprehensive review covers the entire medical curriculum in
									an easy-to-understand manner, making it accessible for all
									students. We offer personalized support from experienced
									mentors to guide you along the way. Join us on your journey to
									success in medicine.
								</p>

                <p
                  style={{
                    margin: "0",
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "2rem",
                    gap: "5px",
                    display: " flex",
                    alignItems: "center",
                    margin: 0,
                  }}
                >
                  <i
                    class="fa-solid fa-check"
                    style={{
                      color: "rgb(255, 198, 0)", paddingRight: "3px",
                    }}
                  /> Proven exam strategies designed to improve your score
                </p>
                <p
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "2rem",
                    display: " flex",
                    alignItems: "center",
                    margin: 0,
                  }}
                >
                  <i
                    class="fa-solid fa-check"
                    style={{ color: "rgb(255, 198, 0)", paddingRight: "7px" }}
                  ></i>
                  In-depth explanations of correct and incorrect answers
                </p>
                <p
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "2rem",
                    display: " flex",
                    alignItems: "center",
                    margin: 0,
                  }}
                >
                  <div>
                    <i
                      class="fa-solid fa-check"
                      style={{ color: "rgb(255, 198, 0)", paddingRight: "7px", }}
                    ></i>
                  </div>
                  Bullet-points, tables, diagrams, illustrations, photos and
                  color coding{" "}
                </p>
                <p
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "2rem",
                    display: " flex",
                    alignItems: "center",
                    margin: 0,
                  }}
                >
                  <i
                    class="fa-solid fa-check"
                    style={{ color: "rgb(255, 198, 0)", paddingRight: "7px" }}
                  ></i>
                  Revised Updates by Educational Experts
                </p>
                {/* <div style={{backgroundColor:'#FFC600'}}>
    </div>                    */}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="container">
				<div className="row">
					<h6
						style={{
							paddingTop: "90px",
							fontSize: "16px",
							fontWeight: "600",
							textTransform: "uppercase",
							textShadow: "0px 0px 10px rgb(0 0 0 / 30%)",
							color: "#fec329",
							margin: "0px 0px 15px 0px",
							textAlign: "center",
							fontFamily: "Poppins",
						}}
					>
						MEET OUR TEAM
					</h6>
					<h1
						style={{
							textAlign: "center",
							fontFamily: "Playfair Display",
							fontSize: "46px",
							fontWeight: "900",
							lineHeight: "1.2em",
							color: "#222",
							margin: "0px 0px 5px 0px",
						}}
					>
						Introducing the Maps Medics Team
					</h1>
				</div>
				<div
					className="row p-3"
					style={{ display: "flex", justifyContent: "center" }}
				>
					<div className="col-md-5 elCard p-1 col-xxl-5">
						<div className="mainContainer">
							<div className="theCard">
								<div className="theFrontMostafa"></div>
								<div
									className="theback"
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
									}}
								>
									<div className="container">
										<div
											className="row "
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											<div className="col-md-12 col-sm-12">
												<h2
													style={{
														color: "#000",
														textAlign: "center",
														fontSize: "20px",
														fontWeight: "900",
														textTransform: "uppercase",
														lineHeight: "42px",
														margin: "0",
														fontFamily: "Poppins",
													}}
												>
													FOUNDER & CEO
												</h2>

												<h3
													className="text-center"
													style={{
														fontFamily: "Playfair Display",
														fontSize: "34px",
														fontWeight: "900",
														lineHeight: "1.2em",
													}}
												>
													Dr. Mostafa Abdeen
												</h3>
												<p
													className="soghayar"
													style={{ fontFamily: "Poppins", textAlign: "center" }}
												>
													The visionary behind Maps Medics. Dr. Abdeen believes
													that education has the power to transform lives and
													relieve suffering and hopes to help make medical
													education as simple and accessible as possible so that
													all students can succeed.
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* <img src={mostafa} alt="" style={{border:'1px solid #fff' , borderRadius:'20px', position:'relative'}}/> */}
						<div className="container p-2 smedia">
							{/* <div className='p-2' style={{border:'1px solid #FFC600' , borderRadius:'25px', position:'relative', top:'-7%', backgroundColor:'#fff'}}> */}
							<div
								className="row smediaInternal"
								style={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									paddingTop: "11%",
								}}
							>
								{/* <div className="col-md-10 col-sm-10 col-xs " style={{width:'83%'}}>
                                <h2 style={{color:'#FFC600' , textAlign:'center', fontSize:'15px', fontWeight:'500',textTransform:'uppercase', lineHeight:'42px', margin:'0'}}>FOUNDER & CEO</h2>
<h3  style={{ fontFamily:"Playfair Display", fontSize:'21px', fontWeight:'900', lineHeight:'1.2em' }}>Dr. Mostafa Abdeen</h3>
<p  style={{fontFamily:'Poppins'}}>The visionary behind Maps Medics. Dr. Abdeen believes that education has the power to transform lives and relieve suffering and hopes to help make medical education as simple and accessible as possible so that all students can succeed.</p>
                                </div> */}
								<div
									className="col-md-6 col-sm-2 col-xs socialmedia"
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										flexDirection: "row",
									}}
								>
									<a
										href="mailto:info@mapsmedics.com"
										style={{ padding: "2px" }}
									>
										<div style={{ marginBottom: "4%" }}>
											<i class="envelope fa-solid fa-envelope p-3"></i>
										</div>{" "}
									</a>
									<a
										href="https://www.facebook.com/mustapha96"
										target="_blank"
										style={{ padding: "2px" }}
									>
										<div style={{ marginBottom: "4%" }}>
											<i class="facebook fa-brands fa-facebook p-3"></i>
										</div>
									</a>
									<a
										href=""
										style={{ textDecoration: "none", padding: "2px" }}
										onClick={() => {
											window.open(`https://wa.me/+201112223359`);
										}}
									>
										<div>
											<i class="whatsapp fa-brands fa-whatsapp p-3"></i>
										</div>
									</a>
								</div>
							</div>

							{/* </div> */}
						</div>
					</div>{" "}
					<div className="col-md-1 col-xxl-1"></div>
					<div className="col-md-5 elCard p-1 col-xxl-5">
						<div className="mainContainer">
							<div className="theCard">
								<div className="theFrontAbdel"></div>
								<div
									className="theback"
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
									}}
								>
									<div className="container">
										<div
											className="row "
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											<div className="col-md-12">
												<h2
													style={{
														color: "#000",
														textAlign: "center",
														fontSize: "20px",
														fontWeight: "900",
														textTransform: "uppercase",
														lineHeight: "42px",
														margin: "0",
														fontFamily: "Poppins",
													}}
												>
													CTO
												</h2>

												<h3
													className="text-center"
													style={{
														fontFamily: "Playfair Display",
														fontSize: "34px",
														fontWeight: "900",
														lineHeight: "1.2em",
													}}
												>
													Dr. Abdelrahman Elmorshdy
												</h3>
												<p
													className="soghayar"
													style={{ fontFamily: "Poppins", textAlign: "center" }}
												>
													The technological mastermind behind Maps Medics. Dr.
													Elmorshdy combines his passion for technology with his
													expertise in medicine to create an unparalleled
													e-learning experience for medical students. He
													continues to push the boundaries of what's possible,
													to empower medical students to achieve their full
													potential.
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* <img src={abdelrahman} alt="" style={{border:'1px solid #fff' , borderRadius:'20px', position:'relative'}}/> */}
						<div className="container p-2 smedia">
							{/* <div className='p-2' style={{border:'1px solid #FFC600' , borderRadius:'25px', position:'relative', top:'-7%', backgroundColor:'#fff'}}> */}
							<div
								className="row smediaInternal"
								style={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									paddingTop: "11%",
								}}
							>
								<div
									className="col-md-6 col-sm-2  socialmedia"
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										flexDirection: "row",
									}}
								>
									<a
										href="mailto:info@mapsmedics.com"
										style={{ padding: "2px" }}
									>
										<div style={{ marginBottom: "4%" }}>
											<i class="envelope fa-solid fa-envelope p-3"></i>
										</div>
									</a>
									<a
										href="https://www.facebook.com/elmors7dy"
										style={{ padding: "2px" }}
										target="_blank"
									>
										<div style={{ marginBottom: "4%" }}>
											<i class="facebook fa-brands fa-facebook p-3"></i>
										</div>
									</a>
									<a
										href=""
										style={{ textDecoration: "none", padding: "2px" }}
										onClick={() => {
											window.open(`https://wa.me/+201000119784`);
										}}
									>
										<div>
											<i class="whatsapp fa-brands fa-whatsapp p-3"></i>
										</div>
									</a>
								</div>
							</div>

							{/* </div> */}
						</div>
					</div>
				</div>
				<div
					className="row p-3"
					style={{ display: "flex", justifyContent: "center" }}
				>
					<div className="col-md-5 elCard p-1 col-xxl-5">
						<div className="mainContainer">
							<div className="theCard">
								<div className="theFrontmahmoud"></div>
								<div
									className="theback"
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
									}}
								>
									<div className="container">
										<div
											className="row "
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											<div className="col-md-12">
												<h2
													style={{
														color: "#000",
														textAlign: "center",
														fontSize: "20px",
														fontWeight: "900",
														textTransform: "uppercase",
														lineHeight: "42px",
														margin: "0",
														fontFamily: "Poppins",
													}}
												>
													COO
												</h2>

												<h3
													className="text-center"
													style={{
														fontFamily: "Playfair Display",
														fontSize: "34px",
														fontWeight: "900",
														lineHeight: "1.2em",
													}}
												>
													Dr. Mahmoud Saleh
												</h3>
												<p
													className="soghayar"
													style={{ fontFamily: "Poppins", textAlign: "center" }}
												>
													The driving force behind Maps Medics excellence. Dr.
													Saleh is an exceptional medical professional
													interested in business management, and he ensures that
													our operations run smoothly and that our students
													receive the best experience possible. He is dedicated
													to providing top-notch quality and making education
													more accessible for all medical students.
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* <img src={mahmoud} alt="" style={{border:'1px solid #fff' , borderRadius:'20px', position:'relative'}}/> */}
						<div className="container p-2 smedia">
							{/* <div className='p-2' style={{border:'1px solid #FFC600' , borderRadius:'25px', position:'relative', top:'-7%', backgroundColor:'#fff'}}> */}
							<div
								className="row smediaInternal"
								style={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									paddingTop: "11%",
								}}
							>
								{/* <div className="col-md-10 col-sm-10" style={{width:'83%'}}>
                                <h2 style={{color:'#FFC600' , textAlign:'center', fontSize:'15px', fontWeight:'500',textTransform:'uppercase', lineHeight:'42px', margin:'0'}}>COO</h2>
<h3   style={{ fontFamily:"Playfair Display", fontSize:'21px', fontWeight:'900', lineHeight:'1.2em' }}>Dr. Mahmoud Saleh
</h3>
<p  style={{fontFamily:'Poppins'}}>Founder and chief visionary, Mostafa is the driving force behind the company. He loves to keep his hands full by participating in the development of the content, marketing, and customer experience strategies.</p>
                                </div> */}
								<div
									className="col-md-6 col-sm-2 socialmedia"
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										flexDirection: "row",
									}}
								>
									<a
										href="mailto:info@mapsmedics.com"
										style={{ padding: "2px" }}
									>
										<div style={{ marginBottom: "4%" }}>
											<i class="envelope fa-solid fa-envelope p-3"></i>
										</div>
									</a>
									<a
										href="https://www.instagram.com/dr.mahmoudsalehofficial/"
										style={{ padding: "2px" }}
										target="_blank"
									>
										<div>
											<i class="instagram fa-brands fa-instagram p-3"></i>
										</div>
									</a>

									<a
										href=""
										style={{ textDecoration: "none", padding: "2px" }}
										onClick={() => {
											window.open(`https://wa.me/+201033174953`);
										}}
									>
										<div>
											<i class="whatsapp fa-brands fa-whatsapp p-3"></i>
										</div>
									</a>
								</div>
							</div>

							{/* </div> */}
						</div>
					</div>
					<div className="col-md-1 col-xxl-1"></div>
					<div className="col-md-5 elCard p-1 col-xxl-5">
						<div className="mainContainer">
							<div className="theCard">
								<div className="theFront"></div>
								<div
									className="theback"
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
									}}
								>
									<div className="container">
										<div
											className="row "
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											<div className="col-md-12">
												<h2
													style={{
														color: "#000",
														textAlign: "center",
														fontSize: "20px",
														fontWeight: "900",
														textTransform: "uppercase",
														lineHeight: "42px",
														margin: "0",
														fontFamily: "Poppins",
													}}
												>
													CDO
												</h2>

												<h3
													className="text-center"
													style={{
														fontFamily: "Playfair Display",
														fontSize: "34px",
														fontWeight: "900",
														lineHeight: "1.2em",
													}}
												>
													Dr. Youssef Heikal
												</h3>
												<p
													className="soghayar"
													style={{ fontFamily: "Poppins", textAlign: "center" }}
												>
													The artistic eye of Maps Medics. Dr. Heikal is an
													experienced medical professional with an eye for
													design, and he is responsible for the look and feel of
													our platform, and our astounding diagrams and
													illustrations. He combines his medical knowledge with
													his passion for design to create a visually pleasing
													and effective learning experience for our students.
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* <img src={youssef} alt="" style={{border:'1px solid #fff' , borderRadius:'20px' , position:'relative'}}/> */}
						<div className="container p-2 smedia">
							{/* <div className='p-2' style={{border:'1px solid #FFC600' , borderRadius:'25px', position:'relative', top:'-7%', backgroundColor:'#fff'}}> */}
							<div
								className="row smediaInternal"
								style={{
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									paddingTop: "11%",
								}}
							>
								{/* <div className="col-md-10 col-sm-10" style={{width:'83%'}}>
                                <h2 style={{color:'#FFC600' , textAlign:'center', fontSize:'15px', fontWeight:'500',textTransform:'uppercase', lineHeight:'42px', margin:'0'}}>CDO</h2>
<h3  style={{ fontFamily:"Playfair Display", fontSize:'21px', fontWeight:'900', lineHeight:'1.2em' }}>Dr. Youssef Heikal</h3>
<p  style={{fontFamily:'Poppins'}}>Founder and chief visionary, Mostafa is the driving force behind the company. He loves to keep his hands full by participating in the development of the content, marketing, and customer experience strategies.</p>
                                </div> */}

								<div
									className="col-md-6 col-sm-2 socialmedia"
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										flexDirection: "row",
									}}
								>
									<a href="mailto:info@mapsmedics.com">
										<div style={{ marginBottom: "4%" }}>
											<i class="envelope fa-solid fa-envelope p-3"></i>
										</div>
									</a>
								</div>
							</div>

							{/* </div> */}
						</div>
					</div>
				</div>
			</div>
			<div class="section section-padding mt-n1" style={{ paddingTop: "5%" }}>
				<div class="container ">
					<div className="row">
						<div className="col-md-7">
							<h5
								class="sub-title"
								style={{
									display: "flex",
									justifyContent: "center",
									fontSize: "16px",
									fontWeight: "600",
									textTransform: "uppercase",
									textShadow: "0px 0px 10px rgb(0 0 0 / 30%)",
									color: "#fec329",
									margin: "0px 0px 15px 0px",
									textAlign: "center",
									fontFamily: "Poppins",
								}}
							>
								INSIGHTS AND UPDATES
							</h5>
							<h3
								class="main-title"
								style={{
									display: "flex",
									justifyContent: "end",
									fontFamily: "Playfair Display",
									fontSize: "46px",
									fontWeight: "900",
									lineHeight: "1.2em",
									color: "#222",
									margin: "0px 0px 5px 0px",
								}}
							>
								Our Recent Blogs & News
							</h3>
						</div>
						<div className="col-md-1"></div>
						<div
							className="col-md-4"
							style={{ display: "flex", alignItems: "end" }}
						>
							<Link to="/blog">
								{" "}
								<button
									class="btn btn-primary btnHover"
									style={{
										padding: "18px 32px 18px 32px",
										border: "#FFC600 1px solid",
										borderRadius: "50px",
										fontWeight: "700",
										fontSize: "15px",
									}}
								>
									VIEW ALL BLOGS<i class="fa-solid fa-arrow-right-long"></i>
								</button>
							</Link>
						</div>
					</div>

					{/* 
            <div class="container">

            
             
                <div class="blog-wrapper">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 p-3" style={{padding:'0'}}>

                            <div class="single-blog" style={{backgroundColor:'#fef9ef', boxShadow:'0px 0px 10px 0px rgb(0 0 0 / 50%)'}}>
                                <div class="blog-image">
                                    <a href="/blog2"><img src={books} alt="Blog"/></a>
                                </div>
                              
                                <div className="container">
                                <div class="blog-content">
                                  

                                  <a href='/blog2' style={{textDecoration:'none'}}><h4 class="title" style={{fontWeight:'700'}}>What is the USMLE?</h4></a>
  <p>What is the USMLE? The United States Medical Licensing Examination...</p>
                                    
  
                                      <a href='/blog3' style={{color:'#61ce70', textDecoration:'none'}} >Read More</a>
                                      <div class="blog-author">
                                          <div class="author" style={{ paddingBottom:'3%'}}>
                                              <div class="author-thumb">
                                                  <a href="#"><img src={miniLogo} alt="Author"/></a>
                                              </div>
                                              <div class="author-name">
                                                  <a class="name" href="#" style={{color:'#ffc600', textDecoration:'none'}} >Maps Team</a><br />
                                                  <span style={{lineHeight:'1.2em', fontFamily:'Poppins', fontWeight:'400'}}> <i class="icofont-calendar"></i> January 27, 2023</span>
  
                                              </div>
                                          </div>
                                     
                                      </div>
                                  </div>
                                </div>
                             
                            </div>

                        </div>
                        <div class="col-lg-4 col-md-6 p-3" style={{padding:'0'}}>

                            <div class="single-blog" style={{backgroundColor:'#fef9ef', boxShadow:'0px 0px 10px 0px rgb(0 0 0 / 50%)'}}>
                                <div class="blog-image">
                                    <a href="/blog3"><img src={call} alt="Blog"/></a>
                                </div>
                                <div className="container">
                                <div class="blog-content">
                                  

                                  <a href='/blog3' style={{textDecoration:'none'}}><h4 class="title" style={{fontWeight:'700'}}>How to Apply for an ECFMG Certification?</h4></a>
  <p>How to Apply for an ECFMG Certification? You can apply...</p>
                                    
  
                                      <a href='/blog2' style={{color:'#61ce70', textDecoration:'none'}} >Read More</a>
                                      <div class="blog-author">
                                          <div class="author" style={{ paddingBottom:'3%'}}>
                                              <div class="author-thumb">
                                                  <a href="#"><img src={miniLogo} alt="Author"/></a>
                                              </div>
                                              <div class="author-name">
                                                  <a class="name" href="#" style={{color:'#ffc600', textDecoration:'none'}} >Maps Team</a><br />
                                                  <span style={{lineHeight:'1.2em', fontFamily:'Poppins', fontWeight:'400'}}> <i class="icofont-calendar"></i> January 27, 2023</span>
  
                                              </div>
                                          </div>
                                     
                                      </div>
                                  </div>
                                </div>
                             
                            </div>

                        </div>
                        <div class="col-lg-4 col-md-6 p-3" style={{padding:'0'}}>

<div class="single-blog" style={{backgroundColor:'#fef9ef', boxShadow:'0px 0px 10px 0px rgb(0 0 0 / 50%)'}}>
    <div class="blog-image">
        <a href="/blog1"><img src={collage} alt="Blog"/></a>
    </div>
    <div className="container">
    <div class="blog-content">
      

      <a href="/blog1" style={{textDecoration:'none'}}><h4 class="title" style={{fontWeight:'700'}}>With numbers: What is the average salary and lifestyle of a physician in the USA?</h4></a>
<p>With numbers: What is the average salary and lifestyle of...</p>
        

          <a href="/blog1" style={{color:'#61ce70', textDecoration:'none'}} >Read More</a>
          <div class="blog-author">
              <div class="author" style={{ paddingBottom:'3%'}}>
                  <div class="author-thumb">
                      <a href="#"><img src={miniLogo} alt="Author"/></a>
                  </div>
                  <div class="author-name">
                      <a class="name" href="#" style={{color:'#ffc600', textDecoration:'none'}} >Maps Team</a><br />
                      <span style={{lineHeight:'1.2em', fontFamily:'Poppins', fontWeight:'400'}}> <i class="icofont-calendar"></i> January 27, 2023</span>

                  </div>
              </div>
         
          </div>
      </div>
    </div>
 
</div>

</div>
                    </div>
                </div>
            

            </div>
        */}
					{/* <Slider {...settings}>
        <div>                                       <img src={blog1} alt="" />
</div>
        <div>                                       <img src={blog2} alt="" />
</div>
        <div>                                       <img src={blog3} alt="" />
</div>
   
      </Slider> */}
					{/* <Swiper
                    // install Swiper modules
                    modules={[Navigation, Pagination, Autoplay, EffectFade, EffectFlip, EffectCoverflow, EffectCube]}
                    spaceBetween={50}
                    slidesPerView={1}
                    navigation
                    // scrollbar={{ draggable: true }}
                    autoplay={true}
                    loop
                    style={{marginBottom:"5%",marginTop:"5%"}}
className='swiperHome'
                    >
                        
                  
                              
                                   
                                    <SwiperSlide  style={{ textAlign: "center", cursor:"pointer", marginRight:"10px" }}> 
                                     <div style={{ position: 'relative' }}>
                                    <div class="title" style={{position:'absolute', color:'#fff', backgroundColor:'rgba(0,0,0,0.5)', height:'100%',width:'100%', borderRadius:'10px', display:'flex', justifyContent:'center', alignItems:'center'}}>
                                     <h4 style={{color:'#fff'}}>  With Numbers: What is the average salary and lifestyle of a physician in the USA?
                                     <br />
                                     elmorshedy | 10 January, 2023</h4> 
                                    </div> 
                                    
                                       <img src={blog1} alt="" style={{ width: "100%" , borderRadius:'10px', height:'100%' }}/>
  </div> </SwiperSlide>
  <SwiperSlide  style={{ textAlign: "center", cursor:"pointer", marginRight:"10px" }}> 
                                     <div style={{ position: 'relative', display:'flex', justifyContent:'center', alignItems:'center' }}>
                                    <div class="title" style={{position:'absolute', color:'#fff', backgroundColor:'rgba(0,0,0,0.5)', height:'100%',width:'100%', borderRadius:'10px', display:'flex', justifyContent:'center', alignItems:'center'}}>
                                 <h4 style={{color:'#fff'}}> Preparing for the USMLE® Step 1 as a Pass/Fail Exam    <br />
                                 elmorshedy | 31 December, 2022
                                    </h4>                                      <br />
                               
                                    </div> 
                                    
                                       <img src={blog2} alt="" style={{ width: "100%" , borderRadius:'10px', height:'100%' }}/>
  </div> </SwiperSlide>
  <SwiperSlide  style={{ textAlign: "center", cursor:"pointer", marginRight:"10px" }}> 
                                     <div style={{ position: 'relative', display:'flex', justifyContent:'center', alignItems:'center' }}>
                                    <div  class="title" style={{position:'absolute', color:'#fff', backgroundColor:'rgba(0,0,0,0.5)', height:'100%', width:'100%',borderRadius:'10px', display:'flex', justifyContent:'center', alignItems:'center'}}>
                              <h4 style={{color:'#fff'}}> USMLE® Step 1 Exam Dates in 2023: What You Need to Know  <br />
                              elmorshedy | 31 December, 2022
                                </h4>                                           <br />
                                    </div> 
                                    
                                       <img src={blog3} alt="" style={{ width: "100%" , borderRadius:'10px', height:'100%' }}/>
  </div> </SwiperSlide>
                                   
                         
                        
                </Swiper>  */}

					<div className="card card-carrier">
						<div style={{ position: "relative" }}>
							<ResponsiveContainer
								carouselRef={ref}
								dots={true}
								render={(width, carouselRef) => {
									let currentVisibleSlide = 3;
									if (width <= 1280) currentVisibleSlide = 3;
									if (width <= 720) currentVisibleSlide = 1;
									return (
										<StackedCarousel
											dots={true}
											ref={carouselRef}
											slideComponent={Slide}
											slideWidth={565}
											carouselWidth={width}
											data={data}
											maxVisibleSlide={5}
											// useGrabCursor
											// disableSwipe={false}
											customScales={[1, 0.75, 0.5, 0.45]}
											transitionTime={450}
											currentVisibleSlide={3}
											fadeDistance={0.1}
										/>
									);
								}}
							/>
							<div
								className="card-button testimonial-left-button"
								size="small"
								onClick={() => ref.current?.goBack()}
							>
								<i class="fa-solid fa-angle-left "></i>{" "}
							</div>
							<div
								className="card-button testimonial-right-button"
								size="small"
								onClick={() => ref.current?.goNext()}
							>
								<i class="fa-solid fa-angle-right "></i>
							</div>
							{/* <div className="owlDots text-center" >
            <button role='button' className='owlDot' style={{cursor:'pointer', border:'1px solid #ffc600', width:'12px', height:'12px' ,margin:'5px 5px', borderRadius:'50%', transition:'all .25s', backgroundColor:'#fff'}}></button>
            <button role='button' className='owlDot' style={{cursor:'pointer', border:'1px solid #ffc600', width:'12px', height:'12px' ,margin:'5px 5px', borderRadius:'50%', transition:'all .25s', backgroundColor:'#fff'}}></button>
            <button role='button' className='owlDot' style={{cursor:'pointer', border:'1px solid #ffc600', width:'23px', height:'10px' ,margin:'5px 5px', borderRadius:'10px',backgroundColor:'#ffc600', transition:'all .25s'}}></button>
            <button role='button' className='owlDot' style={{cursor:'pointer', border:'1px solid #ffc600', width:'12px', height:'12px' ,margin:'5px 5px', borderRadius:'50%', transition:'all .25s', backgroundColor:'#fff'}}></button>

        </div> */}
						</div>
					</div>

					{/* <div class="how-it-work-wrapper">

               
                    <div class="single-work">
                        <img class="shape-1" src={shape15} alt="Shape"/>
<div class="single-blog">
    <div class="blog-image">
        <a href="blog-details-left-sidebar.html"><img src={blog1} alt="Blog"/></a>
    </div>
    <div class="blog-content">
        <div class="blog-author">
        </div>
        <h4 class="title">With Numbers: What is the average salary and lifestyle of a physician in the USA?</h4>
        <div class="blog-meta">
            <div className="row">
            <span> <i class="fa-solid fa-calendar-days"></i> 10 January, 2023</span>
            </div>
            <div className="row">
            <span> <i class="fa-solid fa-heart"></i> elmorshedy </span>
            </div>
        </div>
    </div>
</div>
</div>
               

               
                    <div class="work-arrow">
                        <img class="arrow" src={shape17} alt="Shape"/>
                    </div>
               
               <div class="single-work">
                        <img class="shape-2"  src={shape15} alt="Shape"/>
<div class="single-blog">
    <div class="blog-image">
        <a href="blog-details-left-sidebar.html"><img src={blog3} alt="Blog"/></a>
    </div>
    <div class="blog-content">
        <div class="blog-author">
        </div>
        <h4 class="title">USMLE® Step 1 Exam Dates in 2023: What You Need to Know</h4>
        <div class="blog-meta">
            <div className="row">
            <span> <i class="fa-solid fa-calendar-days"></i> 31 December, 2022</span>
            </div>
            <div className="row">
            <span> <i class="fa-solid fa-heart"></i> elmorshedy </span>
            </div>
        </div>
    </div>
</div>
</div>
               

               
                    <div class="work-arrow">
                        <img class="arrow" src={shape17} alt="Shape"/>
                    </div>
               
                    <div class="single-work">
                    <img class="shape-3" src={shape16} alt="Shape"/>
<div class="single-blog">
    <div class="blog-image">
        <a href="blog-details-left-sidebar.html"><img src={blog2} alt="Blog"/></a>
    </div>
    <div class="blog-content">
        <div class="blog-author">
        </div>
        <h4 class="title">Preparing for the USMLE® Step 1 as a Pass/Fail Exam</h4>
        <div class="blog-meta">
            <div className="row">
            <span> <i class="fa-solid fa-calendar-days"></i> 31 December, 2022</span>
            </div>
            <div className="row">
            <span> <i class="fa-solid fa-heart"></i> el-morshedy </span>
            </div>
        </div>
    </div>
</div>
</div>
               
                    
               

                </div> */}
				</div>
			</div>
			<div
				className="mobile1 section section-padding"
				style={{ position: "relative", paddingBottom: "0" }}
			>
				{/* <img src={mobile1} alt="" /> */}
				<div className="container">
					<div className="row">
						<div
							className="col-md-6 mobileMti"
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<div className="mtiMob">
								<h3
									style={{
										fontSize: "40px",
										fontFamily: "Playfair Display",
										fontWeight: "bold",
									}}
								>
									The key to USMLE,
								</h3>
								<h4
									style={{
										fontSize: "36px",
										fontFamily: "Playfair Display",
										fontWeight: "bold",
									}}
								>
									In the palm of your hand.
								</h4>
								<div
									style={{
										fontSize: "16px",
										fontFamily: "Poppins",
										color: "grey",
										fontWeight: "400",
										lineHeight: "1.5rem",
									}}
								>
									The Maps Medics app is a must-have for medical students aiming
									to excel in their studies and pass the USMLE with confidence.
									With access to Maps Medics Qbank, video library and study
									material, you have everything you need to succeed right at
									your fingertips.
								</div>
								<p
									style={{
										fontSize: "14px",
										fontFamily: "Poppins",
										color: "#000",
										fontWeight: "bold",
										lineHeight: "1.5rem",
									}}
								>
									Download the app for free.
								</p>
								<div className="row" style={{ justifyContent: "space-evenly" }}>
									<button className="btn iPhone" style={{ width: "30%" }}>
										{" "}
										<div
											className="ayhaga"
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											<i
												class="fa-brands fa-apple"
												style={{ color: "#fff", fontSize: "3rem" }}
											></i>
											<div className="ayhaga2" style={{ paddingLeft: "5px" }}>
												{" "}
												<span
													style={{
														fontWeight: "500",
														fontSize: "12pt",
														display: "block",
													}}
												>
													App Store
												</span>
											</div>
										</div>
									</button>
									<button
										className="btn iPhone"
										style={{ width: "30%", padding: "1vw" }}
									>
										{" "}
										<div
											className="ayhaga"
											style={{
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
											}}
										>
											{" "}
											<img
												style={{ width: "20%", marginLeft: "2%" }}
												src={googlePlay}
												alt=""
											/>
											<div className="ayhaga2" style={{ paddingLeft: "5px" }}>
												{" "}
												<span
													style={{
														fontWeight: "500",
														fontSize: "12pt",
														display: "block",
													}}
												>
													Google Play{" "}
												</span>
											</div>
										</div>
									</button>
								</div>
								{/* <div className="container">
            <div className="row">
                <div className="col-md-3">
                <button className='btn iPhone container' >
                     
           <div className="row">
            <div className="col-md-4" style={{display:'flex', justifyContent:'center', alignItems:'center'}}> <div  className="appleimage">
            <img style={{width:'100%'}} src={apple} alt="" />

            </div>
            </div>
            <div className="col-md-8" style={{paddingLeft:'0',display:'flex', justifyContent:'center', alignItems:'center'}}>
                <div className="buttonContent">
                <span style={{fontSize:'14px'}}>Download on the </span><span style={{fontWeight:'500', fontSize:'22px'}}>App Store</span>
                </div>
          
            </div>
           </div>
            </button>
                </div>
                <div className="col-md-3">
                <button className='btn googlePlay container'>
                       <div className="row">
            <div className="col-md-2" style={{paddingRight:'4px'}}>
            <img style={{width:'100%'}} src={googlePlay} alt="" />
            </div>
            <div className="col-md-10" style={{paddingLeft:'0'}}>
            <span style={{fontSize:'14px'}}>GET IT ON</span> <span style={{fontWeight:'500', fontSize:'22px'}}>Google Play</span>
            </div>
           </div>
                         </button>
                        </div>
                        <div className="col-md-6"></div>
            </div>
           </div>
           */}
							</div>
						</div>
						<div className="col-md-6 contentMti">
							<img className="mob" src={mobile2} alt="" />
						</div>
					</div>
				</div>
			</div>
			<div className="lap1 section">
				{/* <img src={lap1} alt=""  /> */}
				<div className="container">
					<div className="row">
						<div
							className="col-md-6 mobileMti"
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<div className="mtiMob">
								<h3
									className="p-3"
									style={{
										fontSize: "130%",
										fontFamily: "Playfair Display",
										fontWeight: "bold",
									}}
								>
									QBank
								</h3>
								<h4
									style={{
										fontSize: "36px",
										fontFamily: "Playfair Display",
										fontWeight: "bold",
									}}
								>
									All you need to know how you need to know it.
								</h4>
								<div
									style={{
										fontSize: "16px",
										fontFamily: "Poppins",
										color: "#fff",
										fontWeight: "400",
										lineHeight: "1.5rem",
										marginBottom: "3%",
									}}
								>
									Our comprehensive NBME-themed Question Bank covers all the
									high yield concepts in board-style questions. Enjoy in-depth
									explanations of each choice, written in color-coded bullet
									points.
								</div>
								<Link
									to="/QBankAdver"
									className="btn btn-primary btnHover2 "
									style={{
										padding: "10px 40px 10px 40px",
										border: "#FFC600 5px solid",
										borderRadius: "50px",
										fontWeight: "700",
										fontSize: "19px",
									}}
								>
									Try Out{" "}
									<i
										class="fa-solid fa-arrow-right-long"
										style={{ paddingLeft: "6px" }}
									></i>
								</Link>
							</div>
						</div>
						<div className="col-md-6 contentMti">
							<img className="mob" src={lap2} alt="" />
						</div>
					</div>
				</div>
			</div>
			<div
				class="section text-center section-padding"
				style={{ paddingTop: "90px", paddingBottom: "0" }}
			>
				<h5
					class="sub-title"
					style={{
						fontSize: "16px",
						fontWeight: "600",
						textTransform: "uppercase",
						textShadow: "0px 0px 10px rgb(0 0 0 / 30%)",
						color: "#fec329",
						margin: "0px 0px 15px 0px",
						textAlign: "center",
						fontFamily: "Poppins",
					}}
				>
					FAQs
				</h5>
				<h2
					class="main-title"
					style={{
						textAlign: "center",
						fontFamily: "Playfair Display",
						fontSize: "46px",
						fontWeight: "900",
						lineHeight: "1.2em",
						color: "#222",
						margin: "0px 0px 20px 0px",
					}}
				>
					Frequently Asked Questions
				</h2>
			</div>
			<div class="section footer-section">
				<div
					class="section section-padding"
					style={{ paddingTop: "30px", paddingBottom: "0" }}
				>
					{/* <img class="shape-1 animation-down" src={shape21} alt="Shape"/> */}

					<div class="container">
						<div class="row">
							<Accordion defaultActiveKey="0">
								<Accordion.Item eventKey="0" style={{ marginBottom: "7px" }}>
									<Accordion.Header>
										{" "}
										What is special about Maps Medics?
									</Accordion.Header>
									<Accordion.Body
										style={{ color: "#000", paddingBottom: "5px" }}
									>
										<span style={{ fontWeight: "bold" }}>Maps Medics</span> is a{" "}
										<span style={{ fontWeight: "bold" }}>comprehensive</span>{" "}
										e-learning platform that helps medical students succeed. Our{" "}
										<span style={{ fontWeight: "bold" }}>case-based</span>{" "}
										approach{" "}
										<span style={{ fontWeight: "bold" }}>
											simulates the USMLE experience,
										</span>{" "}
										and our{" "}
										<span style={{ fontWeight: "bold" }}>video library</span>{" "}
										covering{" "}
										<span style={{ fontWeight: "bold" }}>
											+3,600 board-style questions
										</span>{" "}
										is{" "}
										<span style={{ fontWeight: "bold" }}>
											aligned with the USMLE course outline.
										</span>{" "}
										Our platform uses{" "}
										<span style={{ fontWeight: "bold" }}>simple language</span>{" "}
										and visual aids to make complex concepts easy to understand.
										Our team of experienced educators also offers{" "}
										<span style={{ fontWeight: "bold" }}>
											personalized support.
										</span>{" "}
										Choose Maps Medics to{" "}
										<span style={{ fontWeight: "bold" }}>
											save time and money
										</span>{" "}
										on your medical education journey.
									</Accordion.Body>
								</Accordion.Item>
								<Accordion.Item eventKey="1" style={{ marginBottom: "7px" }}>
									<Accordion.Header style={{ color: "#000" }}>
										What is meant by case-based learning?
									</Accordion.Header>
									<Accordion.Body style={{ color: "#000" }}>
										At <span style={{ fontWeight: "bold" }}>Maps Medics</span>,
										we use{" "}
										<span style={{ fontWeight: "bold" }}>
											case-based learning
										</span>{" "}
										to teach medical students. This{" "}
										<span style={{ fontWeight: "bold" }}>efficient</span> method
										allows students to{" "}
										<span style={{ fontWeight: "bold" }}>
											simulate the USMLE examination from day one
										</span>{" "}
										and involves presenting them with realistic{" "}
										<span style={{ fontWeight: "bold" }}>high-yield</span>{" "}
										clinical cases and having them diagnose and treat the
										patient. This helps students experience{" "}
										<span style={{ fontWeight: "bold" }}>
											board-style questions
										</span>{" "}
										and develop{" "}
										<span style={{ fontWeight: "bold" }}>
											critical thinking, pattern recognition{" "}
										</span>
										and{" "}
										<span style={{ fontWeight: "bold" }}>
											problem-solving skills.
										</span>{" "}
										It also{" "}
										<span style={{ fontWeight: "bold" }}>saves their time</span>{" "}
										as it{" "}
										<span style={{ fontWeight: "bold" }}>
											{" "}
											avoids the traditional approach of using board review
											books.
										</span>{" "}
										Case-based learning is more interactive and engaging,
										allowing students to take an active role in their learning,
										and
										<span style={{ fontWeight: "bold" }}>
											{" "}
											aids retaining information.
										</span>{" "}
										We believe it is an essential part of a comprehensive
										medical education and have integrated it into our platform
										to give students the{" "}
										<span style={{ fontWeight: "bold" }}>
											{" "}
											best possible learning experience.
										</span>
									</Accordion.Body>
								</Accordion.Item>
								<Accordion.Item eventKey="2" style={{ marginBottom: "7px" }}>
									<Accordion.Header>
										What are the languages used by Maps Medics?
									</Accordion.Header>
									<Accordion.Body style={{ color: "#000" }}>
										While our{" "}
										<span style={{ fontWeight: "bold" }}> question bank </span>
										is purely in{" "}
										<span style={{ fontWeight: "bold" }}> English</span> , our{" "}
										<span style={{ fontWeight: "bold" }}>live lectures </span>
										and{" "}
										<span style={{ fontWeight: "bold" }}>
											video library
										</span>{" "}
										are currently conducted in a{" "}
										<span style={{ fontWeight: "bold" }}>
											mix of Arabic and English.{" "}
										</span>{" "}
									</Accordion.Body>
								</Accordion.Item>
								<Accordion.Item eventKey="3" style={{ marginBottom: "7px" }}>
									<Accordion.Header>
										Are the questions discussed by Maps Medics similar to the
										real exam questions?
									</Accordion.Header>
									<Accordion.Body style={{ color: "#000" }}>
										At <span style={{ fontWeight: "bold" }}>Maps Medics</span>,
										we understand how important it is for medical students to be
										well-prepared for the USMLE. That is why we have carefully
										designed our{" "}
										<span style={{ fontWeight: "bold" }}>
											+3,600 high-yield board-style questions
										</span>{" "}
										to{" "}
										<span style={{ fontWeight: "bold" }}>
											simulate the questions that appear on the USMLE exam.
										</span>{" "}
										Our questions are
										<span style={{ fontWeight: "bold" }}>
											{" "}
											developed by experienced educators
										</span>{" "}
										and reviewed by subject matter experts to ensure that they
										are accurate and
										<span style={{ fontWeight: "bold" }}>
											{" "}
											reflect the content and format of the USMLE exam.
										</span>{" "}
										We offer{" "}
										<span style={{ fontWeight: "bold" }}>
											in-depth explanations
										</span>{" "}
										for correct and incorrect choices, and
										<span style={{ fontWeight: "bold" }}>
											{" "}
											continuous updates
										</span>{" "}
										to maintain a high standard of excellence. By practicing
										with these questions, medical students can gain valuable
										experience and{" "}
										<span style={{ fontWeight: "bold" }}>
											boost their chances
										</span>{" "}
										of success on the USMLE.{" "}
									</Accordion.Body>
								</Accordion.Item>
								<Accordion.Item eventKey="4" style={{ marginBottom: "7px" }}>
									<Accordion.Header>
										What is the validity period of Maps Medics subscriptions?
									</Accordion.Header>
									<Accordion.Body style={{ color: "#000" }}>
										We offer
										<span style={{ fontWeight: "bold" }}>
											{" "}
											account validity for a period of 365 days.
										</span>{" "}
										However,{" "}
										<span style={{ fontWeight: "bold" }}>
											if a member has booked their examination date within 2
											months after the expiration of their account, a grace
											period may be offered
										</span>{" "}
										at the discretion of Maps Medics upon e-mail communication.
										We recommend that members keep track of their account
										expiration dates to ensure uninterrupted access to our
										services. If you have any questions or concerns about the
										validity of your Maps Medics account, please don't hesitate
										to contact us for assistance.{" "}
									</Accordion.Body>
								</Accordion.Item>
								<Accordion.Item eventKey="5" style={{ marginBottom: "7px" }}>
									<Accordion.Header>
										Are Maps Medics video lectures downloadable?
									</Accordion.Header>
									<Accordion.Body
										style={{ color: "#000", paddingBottom: "5px" }}
									>
										Maps Medics video lectures are{" "}
										<span style={{ fontWeight: "bold" }}>
											available for online streaming only
										</span>
										, and they are{" "}
										<span style={{ fontWeight: "bold" }}>
											encrypted and protected to prevent unauthorized
											downloading or distribution.
										</span>{" "}
										While it is not possible to download the lectures,{" "}
										<span style={{ fontWeight: "bold" }}>
											members can access them at any time through the Maps
											Medics platform.
										</span>{" "}
										The lectures are also{" "}
										<span style={{ fontWeight: "bold" }}>
											watermarked to ensure the security of our content.
											Distribution of Maps Medics video lectures is strictly
											prohibited
										</span>
										, and any violation of this policy{" "}
										<span style={{ fontWeight: "bold" }}>
											may result in a member's account termination.
										</span>{" "}
										If you have any questions or concerns about the availability
										of our video lectures, please don't hesitate to contact us
										for assistance.
									</Accordion.Body>
								</Accordion.Item>
								<Accordion.Item eventKey="6" style={{ marginBottom: "7px" }}>
									<Accordion.Header>
										When should I start preparing for the USMLE?
									</Accordion.Header>
									<Accordion.Body style={{ color: "#000" }}>
										<span style={{ fontWeight: "bold" }}>
											{" "}
											Start as early as possible.
										</span>{" "}
										You can start preparing for the USMLE during any year of
										your medical school.{" "}
										<span style={{ fontWeight: "bold" }}>
											{" "}
											The first semester of your first year is not too early.
										</span>{" "}
										It is generally advisable for medical students to start
										preparing for the USMLE as early as possible during medical
										school. This is because the USMLE covers a wide range of
										medical knowledge and skills, and it can take time to
										adequately review all of the material. In addition, the
										earlier you start preparing for the USMLE, the more time you
										will have to identify any knowledge gaps and focus on areas
										that need improvement.{" "}
										<span style={{ fontWeight: "bold" }}>
											{" "}
											By starting early, you can also spread out your studying
											over a longer period of time,
										</span>{" "}
										which may help
										<span style={{ fontWeight: "bold" }}>
											{" "}
											reduce stress
										</span>{" "}
										and{" "}
										<span style={{ fontWeight: "bold" }}>
											improve your chances of success{" "}
										</span>
										on the exam.{" "}
									</Accordion.Body>
								</Accordion.Item>
								<Accordion.Item
									eventKey="7"
									style={{ color: "#000", marginBottom: "14px" }}
								>
									<Accordion.Header>
										How can the ECFMG 2024 medical school accreditation deadline
										be avoided?
									</Accordion.Header>
									<Accordion.Body style={{ color: "#000" }}>
										Students can{" "}
										<span style={{ fontWeight: "bold" }}>avoid</span> the
										Educational Commission for Foreign Medical Graduates{" "}
										<span style={{ fontWeight: "bold" }}>
											(ECFMG) 2024 accreditation deadline for medical schools
										</span>{" "}
										by
										<span style={{ fontWeight: "bold" }}>
											{" "}
											registering an account on the ECFMG.
										</span>{" "}
										It is important for students to{" "}
										<span style={{ fontWeight: "bold" }}>
											register as early as possible
										</span>{" "}
										before the ECFMG's 2024 medical school accreditation limit
										goes into effect in order to{" "}
										<span style={{ fontWeight: "bold" }}>
											ensure that they are able to take the exam at their
											convenience, even after 2024
										</span>
										. To avoid missing the deadline, students should make sure
										to carefully read and follow all instructions provided by
										the ECFMG, and{" "}
										<span style={{ fontWeight: "bold" }}>
											ensure that all required documentation is submitted in a
											timely manner.{" "}
										</span>{" "}
									</Accordion.Body>
								</Accordion.Item>
							</Accordion>
						</div>
					</div>

					{/* <img class="shape-2 animation-left" src={shape22} alt="Shape"/> */}
				</div>

				{/* <div class="footer-copyright">
    <div class="container">

        <div class="copyright-wrapper">
            <div class="copyright-link">
                <a href="#">Terms of Service</a>
                <a href="#">Privacy Policy</a>
                <a href="#">Sitemap</a>
                <a href="#">Security</a>
            </div>
            <div class="copyright-text">
                <p>&copy; 2021 <span> Edule </span> Made with <i class="icofont-heart-alt"></i> by <a href="#">Codecarnival</a></p>
            </div>
        </div>
        

    </div>
</div> */}
			</div>
			{/* <Footer /> */}
		</>
	);
};

export default Home;
